import { makeStyles } from '@material-ui/core/styles';
import { getStyle, mergeStyles } from './stylesSelector';
import { cloneDeep } from 'lodash';
import { styleBreakDesktop, styleBreakMobile } from '../components/utilities/layouts/Globals';
import { FONT_WEIGHT_BOLD } from '../components/utilities/Material';

export const NextUpComponentStyle = makeStyles(theme => {
    /* Default Styles */
    const defaultstyles = {
        linkStyle: {
            color: theme.palette.primary.dark,
            fontWeight: FONT_WEIGHT_BOLD,
            marginTop: theme.spacing(2),
            cursor: 'pointer',
            padding: `0 ${theme.spacing(3)}px`,
        },
        card: {
            padding: theme.spacing(0),
        },
        H2: {
            marginBottom: theme.spacing(1),
            [styleBreakDesktop(theme)]: {
                marginBottom: theme.spacing(2),
            },
        },
        nextUpBox: {
            marginTop: theme.spacing(6),
            marginBottom: theme.spacing(0),
            [styleBreakMobile(theme)]: {
                marginTop: theme.spacing(5),
            },
        },
        roundedBorder: {
            boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.25)',
            borderRadius: '5px',
        },
        cardContentRoot: {
            height: 'fit-content',
            paddingTop: theme.spacing(3),
            paddingBottom: theme.spacing(3),
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(0),
        },
        cardMediaBox: {
            [styleBreakDesktop(theme)]: {
                marginTop: theme.spacing(1),
                marginBottom: theme.spacing(1),
                marginLeft: theme.spacing(6),
            },
            [styleBreakMobile(theme)]: {
                marginTop: theme.spacing(6.75),
                marginBottom: theme.spacing(2),
            },
        },
        cardMediaBoxFlexStyle: {
            display: 'flex',
            alignItems: 'flex-end',
            [styleBreakDesktop(theme)]: {
                marginTop: theme.spacing(0),
                marginBottom: theme.spacing(0),
                marginLeft: theme.spacing(0),
            },
            [styleBreakMobile(theme)]: {
                marginTop: theme.spacing(0),
                marginBottom: theme.spacing(0),
            },
        },
        cardText: {
            maxWidth: theme.spacing(74.5),
            letterSpacing: theme.spacing(0.02),
        },
        wrappedCardContentRoot: {
            height: 'fit-content',
            width: '100%',
            padding: `${theme.spacing(3)}px 0 0 0`,
        },
        subtitle: {
            padding: `0 ${theme.spacing(3)}px`,
        },
        wrappedContainer: {
            width: '100%',
            display: 'flex',
        },
        wrappedContainerFlexChild: {
            width: '100%',
        },
        wrappedContainerBodyText: {
            padding: `0 ${theme.spacing(3)}px`,
            paddingRight: `${theme.spacing(3) + 6}px`,
        },
    };

    const floatedImageProps = {
        float: 'right',
        height: '100%',
        width: '127px', // max image width
        display: 'flex',
        alignItems: 'flex-end',
        shapeOutside: 'inset(calc(100% - 105px) -11px -10px 1px)',
        transform: `scale(1.1) translateY(${theme.spacing(5)}px) translateX(-${theme.spacing(2) - 2}px);`,
        marginLeft: `${theme.spacing(2) + 3}px`,
    };

    // overrides to the default
    /* Add watchman specific styles */
    const watchmanstyles = mergeStyles(cloneDeep(defaultstyles), {
        floatedImage: {
            ...floatedImageProps,
            maxHeight: `${theme.spacing(10)}px`,
            '@media (max-width:622px)': {
                maxHeight: '100%',
                transform: `scale(1.1) translateX(-${theme.spacing(1) - 3}px) translateY(${theme.spacing(3)}px)`,
            },
            '@media (max-width:478px)': {
                shapeOutside: 'inset(calc(100% - 113px) -11px -10px -13px)',
                marginLeft: `${theme.spacing(1) - 2}px`,
                maxHeight: '94%',
                transform: `translateX(-${theme.spacing(1) - 3}px) translateY(${theme.spacing(4) + 4}px)`,
            },
            '@media (max-width:414px)': {
                marginLeft: '6px',
                maxHeight: '96%',
                transform: `translateX(-${theme.spacing(1) - 3}px) translateY(${theme.spacing(4) + 6}px)`,
            },
            '@media (max-width:376px)': {
                shapeOutside: 'inset(calc(100% - 112px) -11px -10px -19px)',
                maxHeight: '100%',
                transform: `translateX(-${theme.spacing(1) - 3}px) translateY(${theme.spacing(3) + 4}px)`,
            },
        },
    });

    /* Add ned specific styles */
    // overrides to the default
    const nedstyles = mergeStyles(cloneDeep(defaultstyles), {
        floatedImage: {
            ...floatedImageProps,
            width: '112px',
            shapeOutside: 'inset(calc(100% - 91px) 0 0)',
            transform: `translate(-10px, ${theme.spacing(3)}px)`,
            justifyContent: 'flex-end',
            [styleBreakMobile(theme)]: {
                shapeOutside: 'inset(calc(100% - 69px) 0 0)',
                transform: `scale(1.25) translateY(${theme.spacing(1)}px) translateX(-${theme.spacing(2) - 1}px)`,
            },
        },
    });

    return getStyle({
        ned: nedstyles,
        watchman: watchmanstyles,
    });
});
